export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_STORAGE_KEY = 'jobseeqrSeekersLanguage';
export const LOGIN_LANGUAGE_OVERRIDE_KEY = 'jobseeqrSeekersLoginLanguage';
export const SUPPORTED_LANGUAGES = ['en', 'ar'];

export function normalizeLanguage(value) {
  const language = String(value || '').trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;
}

export function getActiveLanguage() {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored) return normalizeLanguage(stored);
  }

  if (typeof navigator !== 'undefined') {
    return normalizeLanguage(navigator.language);
  }

  return DEFAULT_LANGUAGE;
}

export function persistActiveLanguage(language) {
  const normalized = normalizeLanguage(language);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  }
  return normalized;
}

export function markLoginLanguageOverride(language) {
  const normalized = normalizeLanguage(language);
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(LOGIN_LANGUAGE_OVERRIDE_KEY, normalized);
  }
  return normalized;
}

export function consumeLoginLanguageOverride() {
  if (typeof window === 'undefined') return '';
  const language = window.sessionStorage.getItem(LOGIN_LANGUAGE_OVERRIDE_KEY);
  window.sessionStorage.removeItem(LOGIN_LANGUAGE_OVERRIDE_KEY);
  return language ? normalizeLanguage(language) : '';
}

export function localeRequestHeaders() {
  const headers = {
    'X-Jobseeqr-Locale': getActiveLanguage(),
  };

  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone) headers['X-Jobseeqr-Time-Zone'] = timeZone;
  } catch {
    // Browsers without resolvedOptions still receive the locale header.
  }

  return headers;
}

export async function saveLocalizationPreferences(user, localization) {
  if (!user) throw new Error('No signed-in user');
  const token = await user.getIdToken();
  const response = await fetch('/api/v1/profile/me', {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...localeRequestHeaders(),
    },
    body: JSON.stringify({ localization }),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Could not save language preferences.');
  }
  return response.json();
}
